import type { VerticalBeamPosition } from "entities/configurator/model/layoutMeta";

export const toOpdekLocalPosition = (
  position: VerticalBeamPosition,
): VerticalBeamPosition => {
  if (position === "left") return "right";
  if (position === "right") return "left";
  return position;
};
